export default function sendUserTimezone(prevTz) {
    return new Promise((resolve, reject) => {
        try {
            let newTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            console.log('act: tz ' + newTz);
            if (newTz !== prevTz) {
                // console.log('prev: tz ' + prevTz);
                    $.ajax({
                        url: '/site/set-user-timezone',
                        data: {tz: newTz},
                        dataType: 'json',
                        type: 'get',
                        headers: {
                            'X-CSRF-TOKEN': yii.getCsrfToken(),
                        },
                    }).done(function (data) {
                        resolve(data);
                    }).fail(function (data) {
                        reject(data.responseText);
                    });
                }
        } catch (e) {
            reject(e);
        }
    });
}
